// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"08d9c210","412":"03aa2880"}[chunkId] + ".chunk.js";
};